<div *ngFor="let material of materialList$ | async; let i = index">
  <ion-card
    #materialRow
    [ngClass]="{
      'selected-item': i === (selectedIndex$ | async),
      'not-selectable-item':
        !material?.editAllowed && i !== (selectedIndex$ | async)
    }"
    class="card-list-item">
    <ion-card-content (click)="onClick(i)">
      <div *ngFor="let col of tableColumns$ | async">
        <div *ngIf="col.selected">
          <ion-label class="admia-list-item-title">
            {{ (col.text | translate) + ': ' }}
          </ion-label>
          <ion-text *ngIf="col.name === columns.Date">
            {{ material.date | date }}
          </ion-text>
          <ion-text *ngIf="col.name === columns.Total">
            {{ material?.price * material?.quantity }}
          </ion-text>

          <div *ngIf="col.name.includes('person')" class="cell-content">
            {{ material['person'][col.name.replace('person.', '')] }}
          </div>

          <ion-text
            *ngIf="
              col.name !== columns.Date &&
              col.name !== columns.Total &&
              !col.name.includes('person')
            ">
            {{ material[col.name] }}
          </ion-text>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
